var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.hasResults
    ? _c(
        "div",
        [
          _c("i", { staticClass: "fa fa-poll" }),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("survey.group.resultsModal.title")))
          ]),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa fa-edit c-pointer",
            on: {
              click: function($event) {
                return _vm.openSurveyResult(_vm.surveyResult.value)
              }
            }
          }),
          _vm._v(" "),
          _c("AnswersModal", { ref: "answerModal" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }